import { urlBuilder } from '@/utils/urls';

export const IamBackend = urlBuilder('/iam/api/v1/', {
  resources: urlBuilder('resources', {
    self: '',
    type: urlBuilder('%s', {
      self: '',
      resourceId: urlBuilder('%s', {
        roles: 'roles',
      }),
    }),
  }),
  users: urlBuilder('users', {
    self: '',
    one: urlBuilder('%s', {
      get: '',
      relations: 'relations',
      roles: urlBuilder('roles', {
        self: '',
        resource: urlBuilder('%s', {
          one: '%s',
        }),
      }),
    }),
    me: urlBuilder('me', {
      get: '',
      resource_permissions: urlBuilder('resource_permissions', {
        one: urlBuilder('%s', {
          get: '',
          byResourceId: '%s',
        }),
      }),
    }),
  }),
  roles: urlBuilder('roles', {
    self: '',
    one: '%s',
  }),
  scopes: urlBuilder('scopes', {
    self: '',
    one: '%s',
  }),
  permissions: urlBuilder('permissions', {
    self: '',
    one: '%s',
  }),
});
